 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"About~ActivityForm~Config~New~NewsForm~StudentActivity~TeacherActivityForm":"About~ActivityForm~Config~New~NewsForm~StudentActivity~TeacherActivityForm","About":"About","ActivityForm~BannerList~ClassForm~ClassList~Config~Dashboard~DisciplineForm~DisciplineList~NewsForm~~eba90900":"ActivityForm~BannerList~ClassForm~ClassList~Config~Dashboard~DisciplineForm~DisciplineList~NewsForm~~eba90900","ActivityForm":"ActivityForm","Config":"Config","NewsForm":"NewsForm","BannerList":"BannerList","ClassForm":"ClassForm","ClassList":"ClassList","Dashboard":"Dashboard","DisciplineForm":"DisciplineForm","DisciplineList":"DisciplineList","New~NewsList~StudentActivity~StudentClass~StudentClasses~StudentForm~TeacherActivityForm~TeacherForm":"New~NewsList~StudentActivity~StudentClass~StudentClasses~StudentForm~TeacherActivityForm~TeacherForm","StudentActivity":"StudentActivity","TeacherActivityForm":"TeacherActivityForm","NewsList":"NewsList","ResponsibleForm~StudentForm~TeacherForm":"ResponsibleForm~StudentForm~TeacherForm","StudentForm":"StudentForm","TeacherForm":"TeacherForm","StudentClass":"StudentClass","StudentClasses":"StudentClasses","Profile":"Profile","ResponsibleForm":"ResponsibleForm","ResponsibleStudents":"ResponsibleStudents","SerieForm":"SerieForm","SerieList":"SerieList","StudentList":"StudentList","TeacherClassList":"TeacherClassList","TeacherList":"TeacherList","TeacherReportCard":"TeacherReportCard","Contact":"Contact","New":"New","login":"login"}[chunkId]||chunkId) + "." + {"About~ActivityForm~Config~New~NewsForm~StudentActivity~TeacherActivityForm":"91780870","About":"5dab5236","ActivityForm~BannerList~ClassForm~ClassList~Config~Dashboard~DisciplineForm~DisciplineList~NewsForm~~eba90900":"e34fbb3b","ActivityForm":"bd459cbd","Config":"c4f302be","NewsForm":"c6c90491","BannerList":"c0a2d2b6","ClassForm":"e9311c96","ClassList":"f215d193","Dashboard":"280b0dc0","DisciplineForm":"56c7fba4","DisciplineList":"bea7cc60","New~NewsList~StudentActivity~StudentClass~StudentClasses~StudentForm~TeacherActivityForm~TeacherForm":"ec6067a1","StudentActivity":"5b710363","TeacherActivityForm":"1e087ee3","NewsList":"e952f1f6","ResponsibleForm~StudentForm~TeacherForm":"215f2499","StudentForm":"9fc08183","TeacherForm":"4f70ee83","StudentClass":"b055bdfb","StudentClasses":"3d5a71d2","Profile":"62903d61","ResponsibleForm":"37f97e10","ResponsibleStudents":"f0697793","SerieForm":"57675854","SerieList":"c589c628","StudentList":"1d7d5c45","TeacherClassList":"fc882473","TeacherList":"dabf57e2","TeacherReportCard":"c14c06be","Contact":"69840c46","New":"8600adf8","login":"8d95ab68"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"About":1,"ActivityForm~BannerList~ClassForm~ClassList~Config~Dashboard~DisciplineForm~DisciplineList~NewsForm~~eba90900":1,"ActivityForm":1,"Config":1,"NewsForm":1,"BannerList":1,"ClassForm":1,"Dashboard":1,"TeacherActivityForm":1,"StudentClass":1,"Profile":1,"TeacherReportCard":1,"Contact":1,"New":1,"login":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"About~ActivityForm~Config~New~NewsForm~StudentActivity~TeacherActivityForm":"About~ActivityForm~Config~New~NewsForm~StudentActivity~TeacherActivityForm","About":"About","ActivityForm~BannerList~ClassForm~ClassList~Config~Dashboard~DisciplineForm~DisciplineList~NewsForm~~eba90900":"ActivityForm~BannerList~ClassForm~ClassList~Config~Dashboard~DisciplineForm~DisciplineList~NewsForm~~eba90900","ActivityForm":"ActivityForm","Config":"Config","NewsForm":"NewsForm","BannerList":"BannerList","ClassForm":"ClassForm","ClassList":"ClassList","Dashboard":"Dashboard","DisciplineForm":"DisciplineForm","DisciplineList":"DisciplineList","New~NewsList~StudentActivity~StudentClass~StudentClasses~StudentForm~TeacherActivityForm~TeacherForm":"New~NewsList~StudentActivity~StudentClass~StudentClasses~StudentForm~TeacherActivityForm~TeacherForm","StudentActivity":"StudentActivity","TeacherActivityForm":"TeacherActivityForm","NewsList":"NewsList","ResponsibleForm~StudentForm~TeacherForm":"ResponsibleForm~StudentForm~TeacherForm","StudentForm":"StudentForm","TeacherForm":"TeacherForm","StudentClass":"StudentClass","StudentClasses":"StudentClasses","Profile":"Profile","ResponsibleForm":"ResponsibleForm","ResponsibleStudents":"ResponsibleStudents","SerieForm":"SerieForm","SerieList":"SerieList","StudentList":"StudentList","TeacherClassList":"TeacherClassList","TeacherList":"TeacherList","TeacherReportCard":"TeacherReportCard","Contact":"Contact","New":"New","login":"login"}[chunkId]||chunkId) + "." + {"About~ActivityForm~Config~New~NewsForm~StudentActivity~TeacherActivityForm":"31d6cfe0","About":"eeff9572","ActivityForm~BannerList~ClassForm~ClassList~Config~Dashboard~DisciplineForm~DisciplineList~NewsForm~~eba90900":"10d9f53c","ActivityForm":"f4c46660","Config":"ba045b01","NewsForm":"ba045b01","BannerList":"13ae8d8e","ClassForm":"370209e8","ClassList":"31d6cfe0","Dashboard":"62d97488","DisciplineForm":"31d6cfe0","DisciplineList":"31d6cfe0","New~NewsList~StudentActivity~StudentClass~StudentClasses~StudentForm~TeacherActivityForm~TeacherForm":"31d6cfe0","StudentActivity":"31d6cfe0","TeacherActivityForm":"b0482163","NewsList":"31d6cfe0","ResponsibleForm~StudentForm~TeacherForm":"31d6cfe0","StudentForm":"31d6cfe0","TeacherForm":"31d6cfe0","StudentClass":"a3017e4d","StudentClasses":"31d6cfe0","Profile":"159ba241","ResponsibleForm":"31d6cfe0","ResponsibleStudents":"31d6cfe0","SerieForm":"31d6cfe0","SerieList":"31d6cfe0","StudentList":"31d6cfe0","TeacherClassList":"31d6cfe0","TeacherList":"31d6cfe0","TeacherReportCard":"a39433f3","Contact":"9aa1c8ea","New":"dbe10823","login":"8d6533e6"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
